import { BASEURL, ENDPOINTS, SPXAPI } from '@/api';

export interface ServerSignUpResponse {
    /** Always null on the public route, which answers uniformly to avoid leaking existence (SPX-6598). */
    userSub: string | null;
    userConfirmed: boolean;
}

export interface ServerSignUpRequest {
    email: string;
    password?: string;
    clientMetadata?: Record<string, string>;
    linkId?: string;
}

export const serverSignUp = async (
    APIInstance: SPXAPI,
    { email, password, clientMetadata, linkId }: ServerSignUpRequest,
): Promise<ServerSignUpResponse> => (
    APIInstance.post(BASEURL.backend(), ENDPOINTS.signUp(), {
        body: {
            email: email.toLowerCase(),
            ...(password !== undefined ? { password } : {}),
            clientMetadata,
            ...(linkId ? { linkId } : {}),
        },
    })
);
